// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"67f76b3f","488":"9d8a72c0","732":"d25b3462"}[chunkId] + ".chunk.js";
};